// Environment configuration for API endpoints
const config = {
  production: {
    API_ENDPOINT: 'https://g6dvrvndnh.execute-api.us-east-1.amazonaws.com/prod/submit',
    S3_BUCKET: 'pacificwarmuseum-form',
    ENVIRONMENT: 'production'
  },
  test: {
    API_ENDPOINT: 'https://qbhlnrn4n8.execute-api.us-east-1.amazonaws.com/test/submit',
    S3_BUCKET: 'test-pacificwarmuseum-form',
    ENVIRONMENT: 'test'
  }
};

// Determine environment from hostname or explicit environment variable
const getEnvironment = () => {
  // Check if we're running in test environment
  if (window.location.hostname.includes('test-pacificwarmuseum-form') || 
      window.location.hostname.includes('localhost') ||
      window.location.hostname === 'd3sltxgqrmp3ot.cloudfront.net' ||
      process.env.REACT_APP_ENV === 'test') {
    return 'test';
  }
  return 'production';
};

const currentEnvironment = getEnvironment();
const currentConfig = config[currentEnvironment];

// Export the current configuration
export default currentConfig;

// Also export the config object for testing
export { config, getEnvironment };
 